import urls from "../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../utils/service";

export const getPaymentMethodDetails = async () => {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.getPaymentMethods, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const makeDefaultPaymentMethod = async (paymentMethodId: string) => {
  const url = `${urls.makeDefaultPaymentMethod}/${paymentMethodId}/default`;
  try {
    const callParams = await getCallParams("PUT");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

const getUrl = (paymentMethod: string) => {
  if (paymentMethod === "paypal") {
    return urls.getPayPalUrl;
  } else if (paymentMethod === "blik") {
    return urls.getBlikUrl;
  } else if (paymentMethod === "p24") {
    return urls.getP24Url;
  }
  return "";
};

export const getPaymentUrl = async (priceId: string, paymentMethod: string) => {
  try {
    const callParams = await getCallParams("POST", { priceId });
    const response = await makeCall(getUrl(paymentMethod), callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
